import { filtersHelper } from '@/utils';

export const propertyCategoryModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
});
